import React from 'react';
import { TabItem, Tabs } from './../../../components/ui';

import { UserAccess } from '../../../lib/types';
import { getPathWithHistoryParams } from '../../../lib/helpers';
import { withUserAccess } from './../../withUserAccess';
import { viewingExternalActs, viewingInternalActs } from './../accessRight';

type Props = {
  userAccess: UserAccess[]
};

export default withUserAccess((props: Props) => {
  const canViewingExternalActs = () =>
    props.userAccess.some(access => viewingExternalActs.includes(access));
  const canViewingInternalActs = () =>
    props.userAccess.some(access => viewingInternalActs.includes(access));

  return (
    <Tabs withRouter>
      {canViewingExternalActs() && (
        <TabItem
          label="Внешние"
          url={getPathWithHistoryParams('/admin/act/')}
          activeUrl={['/admin/act/']}
        />
      )}
      {canViewingInternalActs() && (
        <TabItem
          label="Внутренние"
          url={getPathWithHistoryParams('/admin/act/internal')}
          activeUrl={[
            '/admin/act/internal',
            '/admin/act/internal/defective-statement',
            '/admin/act/internal/os3',
            '/admin/act/internal/outsourcing-act',
            '/admin/act/internal/fuels-act',
            '/admin/act/internal/oils-act',
            '/admin/act/internal/mpz',
            '/admin/act/internal/oil-consumption-accounting'
          ]}
        />
      )}
    </Tabs>
  );
});
